import { t } from '@shared/i18n';
import { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AdminLayout } from './components/AdminLayout';
import { Layout } from './components/Layout';
import Login from './pages/admin/Login';
import DeleteAccount from './pages/DeleteAccount';
import EmailConfirmed from './pages/EmailConfirmed';
import ResetPassword from './pages/ResetPassword';
import Home from './pages/Home';
import Legal from './pages/Legal';
import NotFound from './pages/NotFound';
import Privacy from './pages/Privacy';
import Support from './pages/Support';

// pages organisateur (et la carte) chargées seulement quand on en a besoin
const Dashboard = lazy(() => import('./pages/admin/Dashboard'));
const EventEdit = lazy(() => import('./pages/admin/EventEdit'));
const EventView = lazy(() => import('./pages/admin/EventView'));
const EventLive = lazy(() => import('./pages/admin/EventLive'));
const Events = lazy(() => import('./pages/admin/Events'));
const Members = lazy(() => import('./pages/admin/Members'));
const RouteDetail = lazy(() => import('./pages/admin/RouteDetail'));
const RoutesPage = lazy(() => import('./pages/admin/Routes'));

export default function App() {
  const { pathname } = useLocation();
  // accolades : un effet ne doit rien renvoyer d'autre qu'une fonction de nettoyage
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense fallback={<p className="container muted">{t('Chargement…', 'Loading…')}</p>}>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="confidentialite" element={<Privacy />} />
          <Route path="assistance" element={<Support />} />
          <Route path="suppression-compte" element={<DeleteAccount />} />
          <Route path="nouveau-mot-de-passe" element={<ResetPassword />} />
          <Route path="compte-confirme" element={<EmailConfirmed />} />
          <Route path="mentions-legales" element={<Legal />} />
          <Route path="organisateur/connexion" element={<Login />} />
          <Route path="organisateur" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="membres" element={<Members />} />
            <Route path="evenements" element={<Events />} />
            <Route path="evenements/nouveau" element={<EventEdit />} />
            <Route path="evenements/:id" element={<EventView />} />
            <Route path="evenements/:id/modifier" element={<EventEdit />} />
            <Route path="evenements/:id/direct" element={<EventLive />} />
            <Route path="traces" element={<RoutesPage />} />
            <Route path="traces/:id" element={<RouteDetail />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
